
import { action, makeAutoObservable, runInAction } from 'mobx'
import { injectable, inject, decorate } from 'inversify'
import { BlueUserStore } from '../store'
import { Api } from '@evertel/api'

class UserController {
    userId = 0

    constructor(
        private userStore: BlueUserStore
    ) {
        makeAutoObservable(this, {init: action})
    }

    init(userId: number) {
        if (!userId) return
        this.userId = userId
    }

    getUser(userId) {
        return this.userStore.findById(userId)
    }

    get id() {
        return this.userId
    }

    get user() {
        return this.userStore.findById(this.userId)
    }

    get fullName() {
        if (!this.user || (!this.user.firstName?.trim() && !this.user.lastName?.trim())) return undefined
        return (this.user.firstName + ' ' + this.user.lastName).trim()
    }
}

decorate(injectable(), UserController)
decorate(inject(BlueUserStore), UserController, 0)

export { UserController }
